export default __webpack_public_path__ + "static/media/emotion-xl@2x.bae5f311.png";